import React, { useEffect, useCallback, useState } from 'react';
import {Alert, Button, TextField} from '@betareader/design-system';

import SurveyResults from '../../../content/survey/surveyResults';

import {
  fetchSurveyData
} from '../../../../modules/report';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { authUtil } from '../../../../utils';

const SurveyDataReport = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();

  const currentBook = useSelector(state => state.book.currentBook);
  const surveyData = useSelector(state => state.report.surveyData);

  const fetchingReadingData = useSelector(state => state.report.fetchingReadingData);
  const readerFilters = useSelector(state => state.report.readerFilters);
  const versionFilter = useSelector(state => state.report.versionFilter);

  const [questionTitleFilter, setQuestionTitleFilter] = useState('');

  const getSurveyResults = useCallback(() => {
    if (surveyData) {
      return surveyData.map(version => version.surveyData?.map(survey => (
        <SurveyResults
          style={{ marginBottom: '3em' }}
          versionNumber={version.versionNumber}
          key={survey.surveyId}
          bookId={currentBook._id}
          surveyId={survey.surveyId}
          answers={survey.answers}
          questionTitleFilter={questionTitleFilter}
        />
      )))
    } else {
      return null;
    }
  }, [surveyData, questionTitleFilter, currentBook]);

  useEffect(() => {
    if (!!currentBook) {
      fetchReport();
    }
  }, [currentBook, readerFilters, versionFilter]);

  const fetchReport = async (type) => {
    const idToken = await authUtil.getFreshIdToken();
    if (!idToken) return;
    dispatch(fetchSurveyData(idToken, currentBook._id, versionFilter, readerFilters, type));
  }

  const downloadReport = async () => {
    fetchReport('csv');
  }

  const handleQuestionFilterChange = event => {
    setQuestionTitleFilter(event.target.value);
  }

  if (fetchingReadingData) {
    return (
      <p role="status" aria-live="polite">{t('Loading')}</p>
    )
  }

  if (!surveyData || !(surveyData?.length > 0)) {
    return (
      <Alert>{t('NoAnswer')}</Alert>
    )
  }

  return (
    <React.Fragment>
      <div className="br-survey-report__controls">
        <TextField
          id="survey-question-filter"
          label={t('FindASpecificQuestion')}
          type="search"
          value={questionTitleFilter}
          placeholder={t('FindASpecificQuestion')}
          onChange={handleQuestionFilterChange}
        />
        <Button variant="secondary" onClick={downloadReport}>
          {t('DownloadReport', 'Download report')}
        </Button>
      </div>
      {getSurveyResults()}
    </React.Fragment>
  );
}

export default SurveyDataReport;
